import { cn } from "@/lib/utils"

type ToolsIconProps = {
  className?: string
}

/**
 * Two-slider "Tools" icon (Gemini-like).
 * Uses `currentColor` so it stays consistent with surrounding text colors/themes.
 */
export function ToolsIcon({ className }: ToolsIconProps) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4", className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
        x1="4"
        x2="20"
        y1="8"
        y2="8"
      />
      <circle cx="9" cy="8" r="2" stroke="currentColor" strokeWidth="2" />

      <line
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
        x1="4"
        x2="20"
        y1="16"
        y2="16"
      />
      <circle cx="15" cy="16" r="2" stroke="currentColor" strokeWidth="2" />
    </svg>
  )
}
